import { jsPDF } from "jspdf";
import QRCode from "qrcode";

const BULLETS = [
  "AI drum tabs for almost any song, as sheet music or an easy grid",
  "Play along with real drum sounds, slow it down and loop any part",
  "Ghost notes, accents, R/L sticking and 1st/2nd endings, like printed charts",
  "Fill practice that starts slow and speeds up as you improve",
  "Practice stats, weekly goals and short clips to share your progress",
];

export async function makeWelcomeFlyer({ caption, teacher, referralCode }) {
  const link = `${window.location.origin}/${referralCode ? `?ref=${encodeURIComponent(referralCode)}` : ""}`;
  const qr = await QRCode.toDataURL(link, { margin: 1, width: 300, color: { dark: "#0a0d14", light: "#ffffff" } });
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  const M = 48;
  doc.setFillColor(10, 13, 20);
  doc.rect(0, 0, W, 150, "F");
  doc.setFillColor(0, 240, 255);
  doc.rect(0, 0, W, 6, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(34);
  doc.setTextColor(255, 255, 255);
  doc.text("BEAT", M, 70);
  doc.setTextColor(0, 200, 215);
  doc.text("FLOW", M + doc.getTextWidth("BEAT"), 70);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(13);
  doc.setTextColor(200, 210, 225);
  doc.text("AI drum tabs & practice tools for drummers", M, 96);
  doc.setFontSize(11);
  doc.setTextColor(255, 171, 0);
  doc.text("Welcome to your drum lessons!", M, 124);

  let y = 200;
  doc.setTextColor(20, 20, 20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(26);
  doc.splitTextToSize(caption || (teacher ? `Drum lessons with ${teacher}` : "Your drum lessons"), W - 2 * M).forEach((ln) => { doc.text(ln, M, y); y += 30; });
  const capEnd = y;
  y += 6;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(80, 80, 80);
  doc.text("Practise between lessons with the same app your teacher uses:", M, y);
  y += 26;
  doc.setTextColor(30, 30, 30);
  BULLETS.forEach((b) => {
    doc.setFillColor(0, 184, 196);
    doc.circle(M + 4, y - 4, 3, "F");
    doc.splitTextToSize(b, W - 2 * M - 220).forEach((ln, i) => { doc.text(ln, M + 16, y + i * 15); });
    y += 15 * doc.splitTextToSize(b, W - 2 * M - 220).length + 9;
  });

  const qrS = 170;
  const qx = W - M - qrS;
  const qy = Math.max(270, capEnd + 40);
  doc.setDrawColor(220);
  doc.roundedRect(qx - 10, qy - 10, qrS + 20, qrS + 64, 10, 10);
  doc.addImage(qr, "PNG", qx, qy, qrS, qrS);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(20, 20, 20);
  doc.text("Scan to sign up free", qx + qrS / 2, qy + qrS + 20, { align: "center" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor(90, 90, 90);
  doc.splitTextToSize(link.replace(/^https?:\/\//, ""), qrS + 4).slice(0, 2).forEach((ln, i) => doc.text(ln, qx + qrS / 2, qy + qrS + 34 + i * 9, { align: "center" }));

  y = Math.max(y, qy + qrS + 80) + 10;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(20, 20, 20);
  doc.text("Your first practice:", M, y);
  y += 12;
  doc.setDrawColor(200);
  for (let i = 0; i < 6; i++) { y += 26; doc.line(M, y, W - M, y); }
  y += 40;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(60, 60, 60);
  doc.text("Sign-up link:", M, y);
  doc.setTextColor(0, 140, 155);
  doc.textWithLink(link, M + 72, y, { url: link });

  const H = doc.internal.pageSize.getHeight();
  doc.setFillColor(10, 13, 20);
  doc.rect(0, H - 40, W, 40, "F");
  doc.setFontSize(10);
  doc.setTextColor(200, 210, 225);
  doc.text(window.location.host, W / 2, H - 16, { align: "center" });
  doc.save("BeatFlow_welcome_flyer.pdf");
}
